import axios from 'axios'
import { get } from '@bigyouth/base'

export class Cart {
  static getData () {
    return axios.get('/cart.js')
  }

  static reloadMiniCart () {
    this.getData().then(resp => {
      let cartMini = get('[js-cart-mini]')
      cartMini.innerHTML = `(${resp.data.item_count})`

      if (resp.data.item_count > 0) {
        cartMini.classList.add('has-bg')
      } else {
        cartMini.classList.remove('has-bg')
      }
    })
  }
}
